export default {
  props: {
    // the options of BetterScroll
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/scroll.js